exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-1efa99ba] {\n  margin-top: 12px;\n  text-align: right;\n}\n", ""]);

// exports
